import { INVOICE_TERMS, INVOICE_TERMS_TITLE } from '../../utils/invoiceTerms';

/** On-screen Terms & Condition block for subscription / sale invoices. */
export function InvoiceTermsNotes({ className = '' }) {
  return (
    <div className={`rec-invoice-terms ${className}`.trim()}>
      <h3 className="rec-invoice-terms-title">{INVOICE_TERMS_TITLE}</h3>
      <ul className="rec-invoice-terms-list">
        {INVOICE_TERMS.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  );
}

export default InvoiceTermsNotes;
